import React from 'react'

import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'

// https://blog.mailtrap.io/email-obfuscation/
// dataItemName for tracking clicks
/**
 * @param {string} user
 * @param {string} site
 * @param {string | null} [dataItemName]
 * @param {string | null} [dataTestId]
 */
export const obfuscateEmail = (
  user,
  site,
  dataItemName = null,
  dataTestId = null
) => (
  <a
    data-item-category={TRACKING_CATEGORIES.CONTACT}
    data-item-name={dataItemName}
    data-testid={dataTestId || dataItemName}
    href={`mailto:${user}@${site}`}
  >
    {user}@{site}
  </a>
)
